import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./cost-attribution-missing.i18n.json'));

import './cost-attribution-missing.scss';

type Props = {
  campaignId: number,
  hasAgreedOffers?: boolean
};

const CostAttributionMissing = ({
  campaignId,
  hasAgreedOffers = true
}: Props) => (
  <div className="cost-attribution-missing__notification">
    <SVGDynamicIcon
      height={24}
      width={24}
      customColor="red"
      name="exclamation-inside-circle-custom-bg-white-fg"
    />
    <div className="cost-attribution-missing__note">
      {__t(`cost_attribution_mission.${hasAgreedOffers ? 'cost_distribution_note' : 'no_agreed_offers_note'}`)}
    </div>
    <ActionButton
      link={`/campaigns/${campaignId}/report/v2/cca`}
      disabled={!hasAgreedOffers}
    >
      {__t('cost_attribution_mission.cca_button')}
    </ActionButton>
  </div>
);

export default CostAttributionMissing;
